import { toRFC3339 } from "../utils/time";
import { fetchJson } from "./http";
import type { ServiceSlug, Trace, TraceSummary } from "./types";

export async function getTrace(
  traceId: string,
  serviceSlug: ServiceSlug,
  signal?: AbortSignal,
): Promise<Trace> {
  return fetchJson<Trace>(`/traces/${encodeURIComponent(traceId)}`, {
    serviceSlug,
    signal,
  });
}

export interface GetTracesParams {
  serviceSlug: ServiceSlug;
  startTime: Date;
  endTime: Date;
  serviceNames?: string[];
  serviceInstances?: string[];
  traceIds?: string[];
  minDurationMs?: number | null;
  maxDurationMs?: number | null;  
  minSpanCount?: number | null;
  maxSpanCount?: number | null;
  sort?: string;
  order?: string;
  limit?: number;
  signal?: AbortSignal;
}

export async function getTraces({
  serviceSlug,
  startTime,
  endTime,
  serviceNames = [],
  serviceInstances = [],
  traceIds = [],
  minDurationMs,
  maxDurationMs,
  minSpanCount,
  maxSpanCount,
  sort,
  order,
  limit,
  signal,
}: GetTracesParams): Promise<TraceSummary[]> {
  const result = await fetchJson<TraceSummary[] | null>("/traces", {
    serviceSlug,
    signal,
    searchParams: {
      start_time: toRFC3339(startTime),
      end_time: toRFC3339(endTime),
      service_names: serviceNames.length > 0 ? serviceNames.join(",") : undefined,
      service_instances: serviceInstances.length > 0 ? serviceInstances.join(",") : undefined,
      traceIds: traceIds.length > 0 ? traceIds.join(",") : undefined,
      min_duration_ms: minDurationMs != null ? minDurationMs : undefined,
      max_duration_ms: maxDurationMs != null ? maxDurationMs : undefined,
      min_span_count: minSpanCount != null ? minSpanCount : undefined,
      max_span_count: maxSpanCount != null ? maxSpanCount : undefined,
      sort,
      order,
      limit,
    },
  });
  return Array.isArray(result) ? result : [];
}
